import React from 'react'
import styled from 'styled-components'
import { FlexContainer, device } from 'heliocor-ui'

import Stepper from '@material-ui/core/Stepper'
import StepButton from '@material-ui/core/StepButton'


const WizardFrame = styled(FlexContainer)`
    display: flex;
    background-color: white;
    height: 100vh;
    width: 100vw;
    @media ${device.midSize}{
        margin: 0;
        position: absolute;
        -ms-transform: translate(-50%);
        left: 50%;
        transform: translate(-50%);
        height: 700px;
        width: 800px;
    }
`

const StepperButton = styled(({ setGreyBg, ...rest }) => <StepButton {...rest} />)`
    && {
        .MuiStepIcon-completed{
            fill: ${props => props.setGreyBg && 'rgba(0, 0, 0, 0.38)'};
        }
        .MuiStepIcon-active{
            fill: ${props => props.main};
        }
        .MuiStepLabel-iconContainer {
            display: flex;
            flex-shrink: 0;
            padding-right: 0;
            @media ${device.midSize}{
                padding-right: 8px;
            }
        }
        margin: -16px -16px;
        padding: 8px 16px;
        @media ${device.midSize}{
            margin: -8px -16px;
            padding: 4px 16px;
        }
    }
`

const ActionFlexContainer = styled(FlexContainer)`
    background-color: ${props => props.theme.colors.stepperBackground}
    min-height: 50px;
    padding: 8px;
    height: 5vh;
    position: fixed;
    bottom: 0;
    @media ${device.midSize}{
        position: static;
        height: auto;
    }
`

const WizardContent = styled(FlexContainer)`
    padding: 1rem 0;
    height: 91vh;
    @media ${device.midSize}{
        height: 650px;
        min-width: 640px;
    }
`

const WizardHeader = styled(FlexContainer)`
    height: 5vh;
    justify-content: space-between; 
    padding: 0 1rem 0.5rem 1rem;
    @media ${device.midSize}{
        height: auto;
    }
`

const Container = styled.div`
  height: 100%;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
`

const StepperStyled = styled(({ isMobile, ...rest }) => <Stepper {...rest} />)`
    && {
        background-color: ${props => props.theme.colors.stepperBackground};
        padding: 1rem;
        display: block;
        height: 550px;
        overflow: auto;
        @media ${device.midSize}{
            width: 10rem;
            margin-top: 20%;
        }
    }
`

const StepperBlock = styled(FlexContainer)`
    justify-content: space-between;
    align-items: center;
    @media ${device.midSize}{
        background-color: ${props => props.theme.colors.stepperBackground};
        min-width: 160px;
        justify-content: space-between;
        align-items: center;
    }
`

const PoweredLogo = styled.img`
    width: 100%;
    padding: 0 24px;
    z-index: 10;
    position: relative;
`

const CategoryDescription = styled.div`
    margin-left: 4px;
    font-weight: 300;
    padding: ${props => props.padding || '0 1rem 1rem 1rem'};
    font-size: 13px;

    p {
        font-weight: 300;
        padding-top: 0.25rem;
        font-size: 13px;
        margin-top: 0px;
    }
`

export {
    ActionFlexContainer,
    CategoryDescription,
    Container,
    WizardContent,
    WizardHeader,
    WizardFrame,
    StepperStyled,
    StepperBlock,
    StepperButton,
    PoweredLogo
}
